import { jsxs as t, jsx as e } from "react/jsx-runtime";
const i = (a) => /* @__PURE__ */ t("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1rem", height: "1rem", fill: "none", viewBox: "0 0 32 24", ...a, children: [
  /* @__PURE__ */ e("rect", { width: 31, height: 23, x: 0.5, y: 0.5, fill: "#F6ECFC", stroke: "#E0C1F4", rx: 2.5 }),
  /* @__PURE__ */ e(
    "path",
    {
      fill: "#9736E8",
      fillRule: "evenodd",
      d: "M10.167 7a1.167 1.167 0 1 0 0 2.333 1.167 1.167 0 0 0 0-2.333Zm0 4.03a1.167 1.167 0 1 0 0 2.334 1.167 1.167 0 0 0 0-2.334ZM9 16.23a1.167 1.167 0 1 1 2.333 0 1.167 1.167 0 0 1-2.333 0Zm4.005-9.02a.4.4 0 0 0-.4.4v1.11c0 .22.18.4.4.4H22.6a.4.4 0 0 0 .4-.4V7.61a.4.4 0 0 0-.4-.4h-9.594Zm-.399 4.432a.4.4 0 0 1 .4-.4H22.6c.22 0 .4.18.4.4v1.11a.4.4 0 0 1-.4.4h-9.594a.4.4 0 0 1-.4-.4v-1.11Zm.4 3.63a.4.4 0 0 0-.4.4v1.11c0 .22.18.4.4.4H22.6a.4.4 0 0 0 .4-.4v-1.11a.4.4 0 0 0-.4-.4h-9.594Z",
      clipRule: "evenodd"
    }
  )
] }), o = i;
export {
  o as default
};
